/**
 * Metric Inputs route for the Data Explorer.
 *
 * Mount: add `metricInputsRoute` to `DATA_EXPLORER_ROUTES` in `App.tsx`
 * (same `[path, LazyComponent]` tuple shape), and add a "Metric inputs"
 * sidebar item pointing at `METRIC_INPUTS_PATH`.
 */
import React, { lazy } from 'react';

export const METRIC_INPUTS_PATH = '/data/inputs/growth/media-spend';
export const METRIC_INPUTS_NAV_LABEL = 'Metric inputs';

export const metricInputsRoute: [string, React.LazyExoticComponent<React.FC>] = [
  METRIC_INPUTS_PATH,
  lazy(() => import('./MetricInputsPage.js')),
];
